// Components==============
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import DreamModal from '../DreamModal/DreamModal';
import Modal from '../Modal/Modal';
import ReflectionIcon from '../ReflectionIcon/ReflectionIcon';
import SkillModal from '../SkillModal/SkillModal';
import Video from '../TrainingContent/Video/Video';
import './PersonModal.module.scss';
// =========================

export default function PersonModal({
  setModalIsOpen,
  person,
  originSkill,
}: {
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  person?: PeopleEntity;
  originSkill?: SkillEntity;
}) {
  const translate = useTranslate();

  const { setModal } = useRootModal();

  const dreams = useRedux((state) =>
    person?.dreams?.map((d) => state.dream?.entities.byId[d.id])
  );

  const skills = useRedux((state) =>
    person?.skills?.map((s) => state.skill?.entities.byId[s.id])
  );

  return (
    <Modal
      closeFunction={
        originSkill
          ? () => setModal(<SkillModal selectedSkill={originSkill} />)
          : undefined
      }
      setModalIsOpen={setModalIsOpen}
    >
      <div styleName="content">
        <div styleName="top">
          <img src={`/storage/${person?.image}`} alt={person?.name} />
          <div styleName="person-info">
            <h2>{person?.name}</h2>
            {!!person?.video && <Video link={person?.video} />}
            <p>{person?.description}</p>
          </div>
        </div>
        <div styleName="bottom">
          {!!dreams?.length && (
            <div>
              <h3>{translate('dream.terms.dreams')}</h3>
              <div styleName="grid">
                {dreams.map(
                  (dream) =>
                    !!dream && (
                      <ReflectionIcon
                        key={dream?.id}
                        name={dream?.name}
                        image={dream?.image}
                        onClick={() =>
                          setModal(<DreamModal origin="person" dream={dream} />)
                        }
                      />
                    )
                )}
              </div>
            </div>
          )}
          {!!skills?.length && (
            <div>
              <h3>{translate('reflection.terms.characteristic-skills')}</h3>
              <div styleName="grid">
                {skills.map(
                  (skill) =>
                    !!skill && (
                      <ReflectionIcon
                        key={skill?.id}
                        name={skill?.name}
                        image={`/storage/${skill?.icon}`}
                        type="skill"
                        onClick={() =>
                          setModal(<SkillModal selectedSkill={skill} />)
                        }
                      />
                    )
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
